const $doc = $(document);

$doc.on('click', '.section-stores .storemapper-category-link', function(e) {
  e.preventDefault();

  const $this = $(this);

  $this
    .toggleClass('active');
});



// WEBPACK FOOTER //
// ../assets/js/store-locator.js